<template>
  <div class="correios-ar">
    <img src="/images/shipment/correios/ar.jpg" alt="aviso de recibo" />

    <div class="fields">
      <span class="text-contract">{{ contract }}</span>

      <div class="field-to">
        <p>
          <strong>DESTINATÁRIO: </strong>
        </p>
        <p>
          <span>{{ toName }}</span>
        </p>
        <p>
          <span>{{ toAddress }}<template v-if="toAddress && toLocationNumber">, </template>{{ toLocationNumber }}</span>
        </p>
        <p>
          <span>{{ toComplement }}<template v-if="toComplement && toDistrict">, </template>{{ toDistrict }}</span>
        </p>
        <p>
          <span>{{ toPostalCodeWithZero }} {{ toCity }} - {{ toStateAbbr }}</span>
        </p>
      </div>

      <div class="field-barcode">
        <canvas
          class="barcode"
          :data-value="code"
          data-height="50"
          data-margin="0"
          data-font="arial"
          data-textposition="top"
        />
      </div>

      <div class="field-from">
        <p>
          <strong>REMETENTE: {{ fromName }}</strong>
        </p>
        <p>
          <strong>ENDEREÇO PARA DEVOLUÇÃO DO OBJETO:</strong>
        </p>
        <p>
          <span>{{ fromAddress }}<template v-if="fromAddress && fromLocationNumber">, </template>{{ fromLocationNumber }}</span>
        </p>
        <p>
          <span>{{ fromComplement }}<template v-if="fromComplement && fromDistrict">, </template>{{ fromDistrict }}</span>
        </p>
        <p>
          <span>{{ fromPostalCodeWithZero }} {{ fromCity }} - {{ fromStateAbbr }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { beautifyPostalCode, postalCodeWithZero } from 'commons/js/formatters/PostalCode';

  export default {
    props: {
      contract: {
        type: String,
        required: true
      },
      tracking: {
        type: String,
        required: true
      },
      code: {
        type: String,
        required: true
      },
      fromName: {
        type: String,
        required: false
      },
      fromAddress: {
        type: String,
        required: false
      },
      fromLocationNumber: {
        type: String,
        required: false
      },
      fromComplement: {
        type: String,
        required: false
      },
      fromDistrict: {
        type: String,
        required: false
      },
      fromCity: {
        type: String,
        required: false
      },
      fromStateAbbr: {
        type: String,
        required: false
      },
      fromPostalCode: {
        type: String,
        required: false
      },
      toName: {
        type: String,
        required: false
      },
      toAddress: {
        type: String,
        required: false
      },
      toLocationNumber: {
        type: String,
        required: false
      },
      toComplement: {
        type: String,
        required: false
      },
      toDistrict: {
        type: String,
        required: false
      },
      toCity: {
        type: String,
        required: false
      },
      toStateAbbr: {
        type: String,
        required: false
      },
      toPostalCode: {
        type: String,
        required: false
      }
    },

    computed: {
      fromPostalCodeWithZero() {
        return beautifyPostalCode(postalCodeWithZero(this.fromPostalCode));
      },
      toPostalCodeWithZero() {
        return beautifyPostalCode(postalCodeWithZero(this.toPostalCode));
      },
    },

    mounted() {
      BarCode('.barcode').init();
    },
  }
</script>

<style lang="stylus" scoped>
.correios-ar
  position relative
  text-align center
  overflow hidden
  img
    max-width 100%
    height auto
  strong
    font-weight bold
  .fields
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    color #000
    font-size 12pt
    .text-contract
      position absolute
      top 0.5em
      left 29.5em
    .field-from
      top 15em
    .field-to
      top 3.5em
    .field-barcode
      position absolute
      top 6.5em
      left 2.5em
      transform scale(0.8)
.correios-ar .fields .field-from
.correios-ar .fields .field-to
  position absolute
  left 3.5em
  width 26.5em
  text-align left
  font-size 9pt
.correios-ar .fields .field-from p
.correios-ar .fields .field-to p
  margin 0
  line-height 1

@media print
  .correios-ar
    img
      max-width 99% !important
      padding 1mm 2mm !important

    .text-contract
      top .7em !important
      left 30.5em !important

    .field-from, .field-to
      left 5em !important

    .field-from
      top 16em !important

    .field-to
      top 4.5em !important

    .field-barcode
      top 7em !important
      left 3.8em !important
</style>
